export const HTTP_METHOD_GET = 'GET'
export const HTTP_METHOD_POST = 'POST'
